module.exports = __webpack_public_path__ + "img/aboutUs_img11.33b0812a.svg";